import { useSuspenseQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetEmpreendimentoService } from '@/features/empreendimentos/shared/http/get-empreendimento.service'
import type { TEmpreendimentoBase } from '@/features/empreendimentos/shared/types/empreendimento'
import { empreendimentosKeys } from '@/features/empreendimentos/shared/utils/queries'

export const useDetalhesEmpreendimentoSuspense = (idExterno: number) => {
  return useSuspenseQuery<TEmpreendimentoBase, AxiosError>({
    queryKey: empreendimentosKeys.detalhes(idExterno),
    queryFn: () => new GetEmpreendimentoService().execute(idExterno).then((response) => response.data),
  })
}
